import {
    DsIconModule,
    DsLoadingAreaConfiguration,
    DsLoadingAreaService, DsProgressCircleModule,
    DsRowData,
    DsTableModule,
    DsTabsModule,
} from '@bmw-ds/components';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CriteriaResponse } from '../../models/criteria.model';
import { CriteriaService } from '../../services/criteria.service';
import { CriteriaStoreService } from '../../services/criteria-store.service';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { ReplenishmentService } from '../../services/replenishment.service';
import { RouterModule } from '@angular/router';

import {
  StockReplenishRequest,
  StockReplenishRequestItem,
  StockReplenishResponse,
} from 'src/app/models/stock-replenish-request.model';
import { CosyUrlResponse } from '../../models/cosy-response.model';
import { StockService } from '../../services/stock.service';
import { AuthService } from '../../services/auth.service';
import { take } from 'rxjs';
import {COMMON_IMPORTS} from "../../shared/common-imports";

@Component({
  selector: 'app-replenishment-open-requests',
    imports: [
        DsTableModule,
        CommonModule,
        BreadcrumbComponent,
        DsTabsModule,
        DsIconModule,
        RouterModule,
        DsProgressCircleModule,
        COMMON_IMPORTS
    ],
  templateUrl: './replenish-open-requests.component.html',
  styleUrl: './replenish-open-requests.component.scss',
  standalone: true,
})
export class ReplenishOpenRequestsComponent implements OnInit {
  criteriaData!: CriteriaResponse;
  rowsData: DsRowData[] = [];
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };
  isLoading = false;
  errorMsg = '';

  showResults: boolean = false;
  constructor(
    private readonly loadingAreaService: DsLoadingAreaService,
    private readonly criteriaService: CriteriaService,
    private readonly stockService: StockService,
    private readonly criteriaStoreService: CriteriaStoreService,
    private readonly replenishmentService: ReplenishmentService,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.isAuthenticated().pipe(take(1)).subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.loadCriteriaData(localStorage.getItem('dealerCode') ?? '');
      } else {
        window.location.href = this.authService.getAuthUrl(); // Redirect to the auth URL
      }
    });
  }

  loadCriteriaData(dealerCode: string): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.criteriaService.postCriteriaSelection(dealerCode).subscribe({
      next: (data: CriteriaResponse) => {
        this.criteriaData = data;
        this.cdr.detectChanges();
        this.criteriaStoreService.setCriteriaData(data);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      error: (error: unknown) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.errorMsg = 'Error fetching criteria data';
        console.error('Error fetching criteria data', error);
      },
      complete: () => {
        this.onTabClick('Pending'); // Load default tab
      },
    });
  }

  onTabClick(status: 'Pending' | 'Accepted' | 'Rejected'): void {
    this.showResults = true;
    if (!this.criteriaData?.plantCode) {
      this.rowsData = [];
      return;
    }
    this.isLoading = true;
    this.errorMsg = '';
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: status + ' Requests',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

    const request: StockReplenishRequest = {
      dealerCode: localStorage.getItem('dealerCode') || '',
      status: status,
    };
    console.log('request', request);
    this.replenishmentService.getStockReplenishment(request).subscribe({
      next: (response: StockReplenishResponse) => {
        console.log('response', response);
        this.rowsData = (response.items || []).map(
          (item: StockReplenishRequestItem) => ({
            image: '', // Set image URL if available
            VIN: item.vin,
            modelCode: item.model,
            description: item.modelDescription,
            dateRequested: item.dateCreated,
          })
        ).sort((a, b) => {
          const dateA = new Date(a.dateRequested).getTime();
          const dateB = new Date(b.dateRequested).getTime();
          return dateB - dateA; // Sort in descending order (newest first)
        });
        this.isLoading = false;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.cdr.detectChanges();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      error: (err) => {
        this.rowsData = [];
        this.isLoading = false;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.errorMsg = 'Error loading stock requests';
        console.error('Error loading stock requests', err);
      },
    });
  }

  onPendingTabClick(): void {
    this.onTabClick('Pending');
  }

  onAcceptedTabClick(): void {
    this.onTabClick('Accepted');
  }

  onRejectedTabClick(): void {
    this.onTabClick('Rejected');
  }
}
